export default __webpack_public_path__ + "static/media/homero-re-perdido.41ed6566.mp4";